// extracted by mini-css-extract-plugin
export default {"customBody":"DateFilter_customBody__hV7a2","customFooter":"DateFilter_customFooter__BlMkg","dateRange":"DateFilter_dateRange__7C398"};